export default __webpack_public_path__ + "static/media/noa-40.601ff10b.jpg";